@import 'styles/mixins';
@import 'styles/variables';

.modal {
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: auto;
  width: 1259px;

  header.modalHeaderWrapper {
    padding: 10px 24px;
  }
}

.modalHeader {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
}

.modalBody {
  display: flex;
  min-height: 0;
  overflow: auto;
}

.loader {
  margin: 10% auto;
  text-align: center;
}

.container {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 24px;
  overflow: auto;
}

.defaultsPreview {
  position: absolute;
  top: -99999px;
  left: -99999px;
}

.detailsContainer {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-left: 24px;

  form {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;

    .configuration {
      display: flex;
      flex-direction: column;
      flex: 0 0 250px;
      margin-right: 24px;
      min-height: 0;
      overflow: auto;

      > h2 {
        @include xl-semibold;

        color: var(--neutral-90);
        margin-bottom: 24px;
        padding-left: 12px;
      }
    }

    .previewContainer {
      flex: 1 1 375px;
      border-radius: 16px;
      border: 1px solid var(--neutral-10);
      min-height: 0;
      overflow: auto;
      padding: 24px 32px;

      > header {
        @include header-label;

        color: var(--neutral-40);
      }
    }
  }
}

.textStyleList {
  border-right: 1px solid var(--neutral-10);
  flex: 0 0 200px;
  padding-right: 24px;

  > li {
    border-radius: 4px;
    display: flex;

    &:hover {
      background-color: var(--neutral-10);

      .chevron {
        fill: var(--neutral-30);
      }
    }

    &.active {
      background-color: var(--focus-10);

      .chevron {
        fill: var(--focus-50);
      }
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    > button {
      align-items: center;
      display: flex;
      flex: 1;
      padding: 10px 12px;

      .chevron {
        margin-left: auto;
      }

      .text {
        @include line-clamp;

        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}

.buttons {
  display: flex;
  margin-top: auto;

  .updateButton {
    margin-left: auto;
  }
}
